import { Injectable, Pipe, PipeTransform } from '@angular/core';



export class MapToIterable implements PipeTransform {
  transform(value: any, ..._args: any[]): any {
    let result: Array<any> = [];

    if (value.entries) {
      for (var [key, value] of value.entries()) {
        result.push({ key, value });
      }
    } else {
      for (let key in value) {
        result.push({ key, value: value[key] });
      }
    }

    return result;
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'mapToIterable',
  pure: true
}, ] },
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
